import { combineReducers } from 'redux'

import * as reducer from '../modules/reducer'

export default combineReducers({
  ...reducer
})
